import SmoothScroll from "smooth-scroll"

let offset = window.innerWidth > 1024 ? window.innerWidth * 0.1 : window.innerWidth * 0.21

let smoption = {
    updateURL: false,
    speed: 200,
    easing: 'linear',
    offset: offset,
}

let scroll = new SmoothScroll('a[href*="#"]', smoption);